import { useEffect } from 'react';
import { useFormikContext } from 'formik';

export const useSetClientSideFieldValue = (clientSideFieldName, clienSideFieldValue) => {
    const { setFieldValue } = useFormikContext()

    useEffect(() => {
        setFieldValue(
            clientSideFieldName,
            clienSideFieldValue
        );
      }, [clientSideFieldName, setFieldValue, clienSideFieldValue ]);

};
